import { render, staticRenderFns } from "./CustomLinks.vue?vue&type=template&id=74053268&scoped=true&"
import script from "./CustomLinks.vue?vue&type=script&lang=js&"
export * from "./CustomLinks.vue?vue&type=script&lang=js&"
import style0 from "./CustomLinks.vue?vue&type=style&index=0&id=74053268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74053268",
  null
  
)

export default component.exports